import environment from "../../environment"
import ApiClient from "../../methods/api/apiClient"

export const chats_saver = (chats = null) => (data) => async (dispatch) => {
    if (chats) {
        const ChatData = chats?.data || chats
        const ROOMIDS = ChatData?.map((_data) => _data?.room_id);
        return dispatch({ type: 'CHATS', data: { data: ChatData, roomids: ROOMIDS } })
    } else {
        if (localStorage.getItem('token')) {
            await ApiClient.get(`chat/user/recent-chats/all`, {
                role: "carrier",
                board_id: "",
                user_id: data?.id || data?._id,
            }, environment.chat_api).then(res => {
                if (res.success) {
                    const ROOMIDS = res?.data?.data?.map((_data) => _data?.room_id);
                    return dispatch({ type: 'CHATS', data: { data: res?.data?.data, roomids: ROOMIDS } })
                }
            })
        } else {
            return dispatch({ type: 'CHATS', data: { data: [], roomids: [] } })
        }
    }
}